import React, { useEffect, useMemo, useState } from "react";
import st from "./social-share.module.scss";
import Image from "next/image";
import { useTranslationContext } from "context/translation";
import {
  SocialShareConfigurationQuery,
  getSdk,
} from "services/datocms/generated";
import { createDatoClient } from "services/datocms";
import { useRouter } from "next/router";

const SocialShare = () => {
  const { shareThisArticle } = useTranslationContext();
  const router = useRouter();
  const [socialShareConfig, setSocialShareConfig] =
    useState<SocialShareConfigurationQuery["socialShareConfiguration"]>(null);

  useEffect(() => {
    const fetchSocialShareConfig = async () => {
      const { socialShareConfiguration } = await getSdk(
        createDatoClient(router.isPreview),
      ).SocialShareConfiguration();

      setSocialShareConfig(socialShareConfiguration);
    };

    fetchSocialShareConfig();
  }, [router.isPreview]);

  const currentPageUrl = useMemo(() => {
    return typeof window !== "undefined" ? window.location.href : "";
  }, []);

  return (
    <div className={st.socialShare}>
      <span className={st.shareText}>{shareThisArticle}aaa:</span>
      <div className={st.iconContainer}>
        {socialShareConfig?.facebookShare && (
          <a
            target="_blank"
            href={`https://www.facebook.com/share.php?u=${encodeURIComponent(
              currentPageUrl,
            )}`}
            className={st.socialItem}
          >
            <Image
              src="https://www.datocms-assets.com/114232/1724005231-facebook-icon.svg"
              alt="facebook icon"
              width={0}
              height={0}
              sizes="100vw"
            />
          </a>
        )}
        {socialShareConfig?.linkedinShare && (
          <a
            target="_blank"
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
              currentPageUrl,
            )}`}
            className={st.socialItem}
          >
            <Image
              src="https://www.datocms-assets.com/114232/1724005229-linkedin-icon.svg"
              alt="linkedin icon"
              width={0}
              height={0}
              sizes="100vw"
            />
          </a>
        )}
      </div>
    </div>
  );
};

export default SocialShare;
